import { render } from "./Accordion.vue?vue&type=template&id=0206637f"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"
script.render = render

export default script